const emitir_relacao_de_alunos_transferidos = {
  path: "/emitir-relacao-de-alunos-transferidos",
  redirect: "/emitir-relacao-de-alunos-transferidos",
  meta: {
    breadCrumb:
      "Processo de Matrículas - Emitir Relação de Alunos Transferidos",
  },
  children: [
    {
      path: "/emitir-relacao-de-alunos-transferidos",
      name: "emitir_relacao_de_alunos_transferidos",
      component: () =>
        import(
          "@/views/EmitirRelacaoDeAlunosTransferidos/EmitirRelacaoDeAlunosTransferidosHome.vue"
        ),
    },
  ],
};

export { emitir_relacao_de_alunos_transferidos };
